var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5228 33.1953C22.6479 33.0702 22.8174 33 22.9943 33H27.3333C31.0152 33 34 30.0152 34 26.3333V15.6667C34 11.9848 31.0152 9 27.3333 9H26.3333H10C6.3181 9 3.33334 11.9848 3.33334 15.6667V21V26.3333C3.33334 30.0152 6.3181 33 10 33H13.9289C14.1057 33 14.2753 33.0702 14.4003 33.1953L17.2831 36.078C17.934 36.729 18.9892 36.729 19.6401 36.078L22.5228 33.1953Z",
    fill: "#29C18C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33334 15.3333C9.33334 14.597 9.9303 14 10.6667 14H15.3333C16.0697 14 16.6667 14.597 16.6667 15.3333C16.6667 16.0697 16.0697 16.6667 15.3333 16.6667H10.6667C9.9303 16.6667 9.33334 16.0697 9.33334 15.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33334 25.9998C9.33334 25.2635 9.9303 24.6665 10.6667 24.6665H26.6667C27.403 24.6665 28 25.2635 28 25.9998C28 26.7362 27.403 27.3332 26.6667 27.3332H10.6667C9.9303 27.3332 9.33334 26.7362 9.33334 25.9998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33334 20.6668C9.33334 19.9305 9.9303 19.3335 10.6667 19.3335H17.6667C18.403 19.3335 19 19.9305 19 20.6668C19 21.4032 18.403 22.0002 17.6667 22.0002H10.6667C9.9303 22.0002 9.33334 21.4032 9.33334 20.6668Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 12.6668C36.6667 17.8215 32.488 22.0002 27.3333 22.0002C22.1787 22.0002 18 17.8215 18 12.6668C18 7.51216 22.1787 3.3335 27.3333 3.3335C32.488 3.3335 36.6667 7.51216 36.6667 12.6668Z",
    fill: "#FFBA33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9165 9.68183C26.3834 8.33846 28.2832 8.3385 28.7502 9.68183L28.9935 10.3817L29.7343 10.3968C31.1562 10.4258 31.7432 12.2326 30.6099 13.0918L30.0195 13.5395L30.234 14.2487C30.6459 15.61 29.1089 16.7266 27.9415 15.9143L27.3333 15.4911L26.7251 15.9143C25.5577 16.7266 24.0208 15.61 24.4326 14.2487L24.6472 13.5395L24.0567 13.0918C22.9234 12.2326 23.5105 10.4258 24.9324 10.3968L25.6732 10.3817L25.9165 9.68183Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackNew);
export default __webpack_public_path__ + "static/media/feedbackNew.3c7a1823c4beef95a7d7106c20cd4889.svg";
export { ForwardRef as ReactComponent };